module.exports = __webpack_public_path__ + "img/premb-r-pm.3a8c6094.svg";